'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getOwnPropertyNames = require('babel-runtime/core-js/object/get-own-property-names');

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reduxConnect = require('redux-connect');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ismobilejs = require('ismobilejs');

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

var _language = require('redux/modules/language');

var languageActions = _interopRequireWildcard(_language);

var _mobile = require('redux/modules/mobile');

var mobileActions = _interopRequireWildcard(_mobile);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('components');

var _Translate = require('../../redux/i18n/Translate');

var _Translate2 = _interopRequireDefault(_Translate);

var _styles = require('../../../static/sass/styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise() {
    return _promise2.default.resolve();
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, props) {
  return {
    isMobile: state.mobile.isMobile,
    isTablet: state.mobile.isTablet,
    currentLanguage: state.language.lang,
    nextLanguage: state.language.nextLang
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)((0, _extends3.default)({}, mobileActions, languageActions), dispatch);
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App(props, context) {
    (0, _classCallCheck3.default)(this, App);

    var _this = (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).call(this, props, context));

    _this.addExtraMetadata = function (actualLang, otherLang, actualPath, otherPath, headProps) {
      if (typeof headProps !== 'undefined') {
        headProps.link = [{ 'rel': 'canonical', 'href': _config2.default.baseUrl + actualPath }];
        headProps.htmlAttributes = { 'xmlns': 'http://www.w3.org/1999/xhtml', 'xmlLang': actualLang, 'lang': actualLang, 'xmlns:og': 'http://ogp.me/ns#', 'xmlns:fb': 'http://ogp.me/ns/fb#' };
      }

      return headProps;
    };

    _this.changeLanguage = function () {
      _this.props.changeLanguage(_this.props.currentLanguage, _this.props.location, _reactRouter.browserHistory);
    };

    _this.getUrlNextLang = function () {
      var actualLang = _this.props.currentLanguage;
      var location = _this.props.location;

      var newLang = actualLang === 'es' ? 'en' : 'es';
      var nextUrl = location.pathname;

      /*Separamos url en un array por '/' y limpiamos los vacíos para obtener el último pathname*/
      nextUrl = nextUrl.replace('/' + actualLang + '/', '/' + newLang + '/');
      if (typeof newPath !== "undefined") {
        nextUrl = nextUrl.replace('/' + actualPath + '/', '/' + newPath + '/');
      }

      var actualUrl = location.pathname;

      /*Separamos url en un array por '/' y limpiamos los vacíos para obtener el último pathname*/
      var aUrl = actualUrl.split("/");
      var actualPath = aUrl.filter(function (value) {
        return (0, _keys2.default)(value).length !== 0;
      }).pop();

      nextUrl = nextUrl.replace('/' + actualPath + '/', '/' + _config2.default.urlTraduction[actualPath] + '/');

      return nextUrl;
    };

    _this.state = {
      stateQuiz: 'initial',
      currentQuiz: 0,
      loading: true
    };

    _this.getShareUrl = _this.getShareUrl.bind(_this);
    _this.getShareTwText = _this.getShareTwText.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.setMobile(_ismobilejs2.default.any);
      this.props.setTablet(_ismobilejs2.default.tablet);
      this.props.setApple(_ismobilejs2.default.apple.device);
      setTimeout(function () {
        return _this2.setState({ loading: false });
      }, 0);
    }
  }, {
    key: 'getShareUrl',
    value: function getShareUrl() {
      var shareURL = _config2.default.baseUrl + this.props.location.pathname;
      return shareURL;
    }
  }, {
    key: 'getShareTwText',
    value: function getShareTwText() {
      var shareTwText = "";
      if (_config2.default.app.head[this.props.router.getCurrentLocation().pathname]) {
        shareTwText = _config2.default.app.head[this.props.router.getCurrentLocation().pathname].twitterText;
      }
      return shareTwText;
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        baseUrl: _config2.default.baseUrl,
        project: _config2.default.project,
        projectName: _config2.default.projectName,
        currentLanguage: this.props.currentLanguage,
        urlShare: this.getShareUrl(),
        textTwShare: this.getShareTwText()
      };
    }
  }, {
    key: 'prevDefault',
    value: function prevDefault(e) {
      e.preventDefault();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          strings = _props.strings,
          isMobile = _props.isMobile;


      var actualPath = this.props.location.pathname.replace(_config2.default.projectName + '/', ''); //Le quitamos al pathname la parte correspondiente al proyecto existente sólo en cliente
      var lang = this.props.currentLanguage;
      var nextLang = this.props.nextLanguage;
      var urlNextLang = this.getUrlNextLang();
      urlNextLang = urlNextLang.replace(_config2.default.projectName + '/', '');

      var headProps = _config2.default.app.head[actualPath + this.props.location.search];
      var headPropsComplete = void 0;
      var siteName = '';

      if (typeof headProps !== 'undefined') {
        headPropsComplete = this.addExtraMetadata(lang, nextLang, actualPath, urlNextLang, headProps);
        (0, _getOwnPropertyNames2.default)(headProps.meta).forEach(function (val, idx, array) {
          if (headProps.meta[val].property == 'og:site_name') {
            siteName = headProps.meta[val].content;
          }
        });
      }

      //Es la única manera que he encontrado de conseguir desde este componente (el Wrapper del que pintemos en cada caso) el parámetro introducido en la ruta.
      //La solución, de otro modo, sería migrar a react-router v4 y utilizar render en lugar de component en los <Route.../>, implicando el montaje de los
      //componentes una única vez en lugar de desmontar y volver a montar. En estos momentos preferimos no migrar para evitar ese efecto colateral.
      var customHeaderParameter = this.props.children.props.route.customHeader;
      var customHeader = (0, _classnames2.default)((0, _defineProperty3.default)({
        'headerApp': true
      }, customHeaderParameter, true));

      var loading = this.state.loading;


      var appInitialStyle = {
        opacity: loading ? '0' : '1',
        height: loading ? '100vh' : 'initial',
        transition: 'opacity 500ms linear'
      };
      return _react2.default.createElement(
        'div',
        { className: _styles2.default.app, style: appInitialStyle },
        _react2.default.createElement(_reactHelmet2.default, headPropsComplete),
        _react2.default.createElement(_components.Header, { customClass: customHeader, strings: strings.header, baseLinkTitle: siteName, location: this.props.location }),
        _react2.default.createElement(_components.OldBrowsers, null),
        _react2.default.cloneElement(this.props.children, { parentStrings: strings, key: customHeaderParameter, location: this.props.location }),
        _react2.default.createElement('div', { className: 'rotateDevice' })
      );
    }
  }]);
  return App;
}(_react.Component), _class2.propTypes = {
  children: _propTypes2.default.object.isRequired,
  changeLanguage: _propTypes2.default.func,
  setLangFromUrl: _propTypes2.default.func,
  location: _propTypes2.default.object.isRequired
}, _class2.contextTypes = {
  store: _propTypes2.default.object.isRequired
}, _class2.childContextTypes = {
  baseUrl: _propTypes2.default.string,
  project: _propTypes2.default.string,
  projectName: _propTypes2.default.string,
  currentLanguage: _propTypes2.default.string,
  urlShare: _propTypes2.default.string,
  textTwShare: _propTypes2.default.string
}, _temp)) || _class) || _class);
exports.default = (0, _Translate2.default)('App')(App);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.js
// module id = 716
// module chunks = 0